export default __webpack_public_path__ + "static/2168-7d93ef38ef9cae139e8969d69336ba7c.gif";